import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const clearUserBenefitSelection = ({ userId, groupId, planId }) =>
  call(websocketFetch, 'clear_user_benefit_selection', {
    user_id: userId,
    group_id: groupId,
    plan_id: planId,
  });
